<template>
  <div>
    <el-tag
      v-if="rowValue != 0"
      :class="ClassObject"
      style="cursor: pointer"
      @click="onClicked(column, row)"
      plain
    >
      {{ Amount }}
      <!--<span v-if="Months.includes(column.property)"></span>-->
    </el-tag>
  </div>
</template>

<script>
import { formatterMoney } from "@/utils";

export default {
  name: "LinkDialogOpenerForPaymentAndInvoicingReport",
  props: {
    rowValue: {
      type: Number,
      default: 0,
      required: true
    },
    row: {
      type: Object,
      default: () => ({}),
      required: true
    },
    column: {
      type: Object,
      default: () => ({}),
      required: true
    },
    call: {
      type: Function,
      default: () => {},
      required: true
    }
  },
  data() {
    return {
      Months: {
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12
      }
    };
  },
  computed: {
    ClassObject() {
      const actualMonth = new Date().getMonth() + 1;
      const isBlue = false;
      let isRed = false;
      let isGreen = false;
      let isYellow = false;

      const now = new Date();
      const endDate = new Date(this.row.EndDate);

      if (this.Months[this.column.property] === actualMonth && now <= endDate) {
        isYellow = true;
        isRed = false;
        isGreen = false;
      }

      if (this.row.Paid === true) {
        isGreen = true;
        isYellow = false;
        isRed = false;
      }
      if (this.row.Paid === false && now > endDate) {
        isRed = true;
        isGreen = false;
        isYellow = false;
      }

      let classObject;
      classObject = {
        Blue: isBlue,
        Red: isRed,
        Green: isGreen,
        Yellow: isYellow,
        Bold: true
      };

      return classObject;
    },
    Amount() {
      let amount = formatterMoney(this.rowValue);
      return amount;
    }
  },
  methods: {
    formatterMoney,
    onClicked(column, row) {
      this.call(column, row);
    }
  }
};
</script>

<style lang="scss" scoped>
.Bold {
  font-weight: bold;
}
.Blue {
  color: blue;
}
.Red {
  color: darkred;
  background-color: lightsalmon;
  border-color: darkred;
}
.Green {
  color: darkgreen;
  background-color: lightgreen;
  border-color: darkgreen;
}
.Yellow {
  color: darkorange;
  background-color: lightgoldenrodyellow;
  border-color: darkorange;
}
</style>
